module.exports = __webpack_public_path__ + "media/images/color_admin_v3/login-bg/bg-8-f8ae4594c31bd227ac07c0220797cf37.jpg";